import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { setNotifications } from 'src/app/data/store/actions/notifications.action';
import { logoutAction } from 'src/app/data/store/actions/users.actions';
import {
  selectCurrentUser,
  selectUnreadCommentsCounter,
} from 'src/app/data/store/selectors/users.selectors';
import { TextSizes, TextType, UserDataImgSize } from 'src/app/shared/enums';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { DropdownContainerComponent } from '../dropdown-container/dropdown-container.component';
import { NotificationsCounterComponent } from '../../../../shared/components/notifications-counter/notifications-counter.component';
import { AsyncPipe } from '@angular/common';
import { NotificationsModalComponent } from '../../../../shared/components/notifications-modal/notifications-modal.component';
import { ImageComponent } from '../../../../shared/components/image/image.component';
import { UserDataComponent } from '../../../../shared/components/user-data/user-data.component';
import { TextComponent } from '../../../../shared/components/text/text.component';
import { GetFullNamePipe } from '../../../../shared/pipe/get-full-name/get-full-name.pipe';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    IonicModule,
    RouterLink,
    DropdownContainerComponent,
    NotificationsCounterComponent,
    NotificationsModalComponent,
    ImageComponent,
    UserDataComponent,
    TextComponent,
    AsyncPipe,
    GetFullNamePipe,
  ],
})
export class HeaderComponent {
  private _store = inject(Store);
  utils = inject(UtilsService);

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly UserDataImgSize = UserDataImgSize;

  public isDropdownOpen = false;

  public isNotificationsOpen = false;

  public currentUser$ = this._store.select(selectCurrentUser);

  public unreadComments$: Observable<number | undefined> = this._store.select(
    selectUnreadCommentsCounter,
  );

  public logout() {
    this._store.dispatch(logoutAction());
    this._store.dispatch(setNotifications({ notifications: [] }));
  }
}
